import MenuCard from './MenuCard';
export default MenuCard;
